import NotificationDetailPageComponent from "../../Notification/components/detail";
import React, {useEffect, useState} from "react";
import API, {ROUTES} from "../../../commons/api/api";
import {useNavigate, useParams} from "react-router-dom";
import ROUTERS from "../../../commons/constans/router";

const NotificationDetailPageContainer  = () => {

    const [dataDetail, setDataDetail] = useState([])
    const [loading, setLoading] = useState(true)
    const navigate = useNavigate();
    const params = useParams();
    var id = params?.id ? params?.id : ''

    const fetchData = async (param = '') =>{
        try {
            const {data: response} = await API.get(ROUTES.API_NOTIFICATION+(param ? '?id='+param : ''));
            if (response?.data) {
                setDataDetail(response?.data);
            }else{
                navigate(ROUTERS.NOTIFICATION)
            }
            setLoading(false)
        } catch (error) {
            console.error(error.message);
            setLoading(false)
        }
    }

    useEffect(() => {
        fetchData(id);
        return () => { id = false };
    }, []);

    const loadMoreData = () => {

    }

    return <NotificationDetailPageComponent loading={loading} dataDetail={dataDetail}

    />;
};

export default NotificationDetailPageContainer ;